// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"91af478a","977":"9d100689"}[chunkId] + ".chunk.js";
};